import SDK from "../SDK";
export const FETCH_BROADCASTUSERS_REQUEST = 'FETCH_BROADCASTUSERS_REQUEST';
export const FETCH_BROADCASTUSERS_SUCCESS = 'FETCH_BROADCASTUSERS_SUCCESS';
export const FETCH_BROADCASTUSERS_FAILURE = 'FETCH_BROADCASTUSERS_FAILURE';
export const RESET_BROADCASTUSERS_LIST = 'RESET_BROADCASTUSERS_LIST';

export const fetchBroadcastusersList = (params) => async (dispatch, getState) => {
  const { page = 1, size = 20, searchTerm = '', status = 'active', reset = false } = params;
  const isrosters = 0; //0-groups and 1-rosters
  
  if (reset) {
    dispatch({ type: RESET_BROADCASTUSERS_LIST });
  }

  dispatch({ type: FETCH_BROADCASTUSERS_REQUEST });

  try {

    const response = await SDK.getBroadCastUsersList(searchTerm, page, size, isrosters)
    
    if ((response?.status && response?.status !== 200) || (response?.statusCode && response?.statusCode !== 200)) {
      throw new Error(response?.message || response?.data?.message || "Unexpected response status");
    }

    const { data, totalPages, totalRecords } = response;

    dispatch({
      type: FETCH_BROADCASTUSERS_SUCCESS,
      payload: {
        broadcastUsers: data.users,
        pagination: {totalPages, totalRecords, currentPage:page},
        reset,
        searchTerm
      }
    });

  } catch (error) {
    dispatch({
      type: FETCH_BROADCASTUSERS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch broadcastUsers'
    });
  }
};
